<template>
  <div class="tasks">
    <div class="tree">
      <el-input v-model="filterText" placeholder="输入关键字进行过滤" clearable />
      <el-tree :data="data" :props="defaultProps" default-expand-all @node-click="handleNodeClick"
        :filter-node-method="filterNode" ref="tree"></el-tree>
    </div>
    <div class="content">
      <task-list-all v-if="projectId === 0"></task-list-all>
      <task-list-tree v-else :projectId="projectId"></task-list-tree>
    </div>
  </div>
</template>

<script>
import TaskListTree from "@/views/projectManage/task/TaskListTree"
import TaskListAll from "@/views/projectManage/task/TaskListAll"
export default {
  name: "Task",
  components: { TaskListTree, TaskListAll },
  data() {
    return {
      projectId: 0,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'projectName'
      },
      filterText: ""
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

  mounted() {
    this.getProjectList();
  },

  methods: {
    getProjectList() {
      this.$http
        .get("basic", "projects/getAllList")
        .then(resp => {
          this.data.push({
            projectName: "项目",
            children: resp
          })
        });
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.projectName.indexOf(value) !== -1;
    },

    handleNodeClick(data) {
      if (data.projectName !== "项目") {
        this.projectId = data.pkid;
      }
    }
  }
}
</script>

<style lang="scss">
.tasks {
  display: flex;
  background-color: #fff;

  .tree {
    height: 100%;
    min-width: 182px;
  }

  .content {
    flex: 1;
    margin-left: 15px;
    overflow: hidden;
  }
}
</style>